import type { EmptyType, FilledType, NullishType } from "@qendo/util";
import { isEmpty } from "lodash";

export function empty(value?: unknown): value is EmptyType {
    if (value === null || value === undefined || value === 0 || value === false) {
        return true;
    }

    switch (typeof value) {
        case "string":
            return value.trim() === "";
        case "object":
            return isEmpty(value);
    }

    return !value;
}

export function nullish(value?: unknown): value is NullishType {
    return (value ?? "filled") !== value;
}

export function filled<T>(value?: T | EmptyType): value is FilledType<T> {
    return !empty(value);
}

export function isEmail(test: string): boolean {
    return /^[^\s@]+@[^\s@]+$/.test(test);
}

export function when<TValue, TResponse>(
    value: TValue | EmptyType,
    callback: (value: TValue) => TResponse,
): TResponse | undefined {
    if (filled(value)) {
        return callback(value);
    }
}
